import {Option} from "../components/inputs/select/options";

export enum GROUPS {
  GROUP_1 = 'group_1',
  GROUP_2 = 'group_2',
  GROUP_3 = 'group_3'
}

export const EVENT_CONFIGS: EventConfig[] = [
  {
    event_id: 24,
    pricesByGroups: [
      {
        group_id: GROUPS.GROUP_1,
        prices: [20, 25, 35]
      },
      {
        group_id: GROUPS.GROUP_2,
        prices: [17, 22, 25]
      },
      {
        group_id: GROUPS.GROUP_3,
        prices: [12, 15, 20]
      }
    ],
    groupOptions: [
      {
        id: GROUPS.GROUP_1,
        itemName: 'Group Name 1'
      },
      {
        id: GROUPS.GROUP_2,
        itemName: 'Group Name 2'
      },
      {
        id: GROUPS.GROUP_3,
        itemName: 'Group Name 3'
      }
    ],
    priceDates: [
      '2022-05-25T00:00:00Z',
      '2022-05-31T00:00:00Z',
      '2022-06-10T00:00:00Z',
    ],
    commission: 0.60,
    backgroundImage: '/assets/images/event_background_24.jpg'
  }
]

export interface EventConfig {
  event_id: number,
  pricesByGroups: {
    group_id: GROUPS,
    prices: number[]
  }[],
  groupOptions: Option[],
  priceDates: string[],
  commission: number,
  backgroundImage: string;

}

export function getEventConfig(event_id: number): EventConfig | null {
  return EVENT_CONFIGS.find((event: EventConfig) => event.event_id === event_id) || null;
}
